// extracted by mini-css-extract-plugin
module.exports = {"container":"container--ContentPanel-Layouts-components__3WWa0"};